import {
  WSCard,
  WSDataItem,
  WSElementProps,
  WSGrid
} from "@wingspanhq/fe-component-library";
import { Worksite } from "@wingspanhq/wingspan-api-sdk";

import styles from "./styles.module.scss";

export interface EngagementInfoPanelProps extends WSElementProps {
  name: string;
  description?: string;
  /** Work site assigned to the engagement — absent for remote engagements. */
  worksite?: Worksite;
  onViewWorksite?: () => void;
}

export const EngagementInfoPanel: React.FC<EngagementInfoPanelProps> = ({
  name,
  description,
  worksite,
  onViewWorksite,
  ...elementProps
}) => {
  return (
    <WSCard {...elementProps}>
      <WSGrid className={styles.panel} gutter="M">
        <WSGrid.Item span={{ xs: "12", s: "6" }}>
          <WSDataItem label={{ text: "Engagement name" }} value={name} />
        </WSGrid.Item>
        {description && (
          <WSGrid.Item span={{ xs: "12", s: "6" }}>
            <WSDataItem label={{ text: "Description" }} value={description} />
          </WSGrid.Item>
        )}
        {worksite && (
          <>
            <WSGrid.Item span={{ xs: "12", s: "6" }}>
              <WSDataItem
                label={{
                  text: "Work site name",
                  action: onViewWorksite
                    ? { label: "View work site", onClick: onViewWorksite }
                    : undefined
                }}
                value={worksite.name}
                secondaryText={worksite.isPrimary ? "Primary" : undefined}
              />
            </WSGrid.Item>
            <WSGrid.Item span={{ xs: "12", s: "6" }}>
              <WSDataItem
                label={{ text: "External ID" }}
                value={worksite.externalId || "–"}
              />
            </WSGrid.Item>
          </>
        )}
      </WSGrid>
    </WSCard>
  );
};
